/* eslint-disable no-useless-escape */
import { booksServerUrl } from './constants';
import { useNavigate } from 'react-router-dom';
import { bookHistory, key_bookUrl } from '../util/constants';
import { getUrlContext, initiate_interval_tree } from './interval_tree.ts';

export function getServerBookUrl(
  bookParent,
  language,
  bookName,
  pageType,
  pageNo
) {
  // for now assume pdf page type, if different do the translation here
  return `${booksServerUrl}/${bookParent}/${language}/${bookName}.pdf${pageNo ? '#page=' + pageNo : ''}`;
}

export function getServerBookUrlFromUrl(url) {
  // for now assume pdf page type, if different do the translation here
  const splitURL = url.split('/');
  const bookParent = splitURL[4];
  const language = splitURL[5];
  const bookName = splitURL[6];
  const pageNo = splitURL[8];

  return getServerBookUrl(bookParent, language, bookName, 'pdf', pageNo);
}

export function isOnMobile() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
function isSameOrigin(url) {
  try {
    // Create a URL object from the string.
    // The URL constructor will correctly parse all its parts.
    const givenUrl = new URL(url, window.location.origin);

    // Compare the origin property of the new URL object
    // with the current window's origin.
    return (
      givenUrl.origin === window.location.origin ||
      givenUrl.origin === 'https://baws.in'
    );
  } catch (error) {
    // If the URL is invalid and cannot be parsed, it's not the same origin.
    console.error('Invalid URL:', error);
    return false;
  }
}
const formatText = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  if (true) {
    // This regex checks if a word consists only of Roman numeral characters.
    const romanNumeralRegex = /^[IVXLCDM\-—\.]+$/i;

    return text
      .toLowerCase()
      .split(' ')
      .map((word) => {
        // If the word matches the Roman numeral pattern, keep it uppercase.
        if (romanNumeralRegex.test(word)) {
          return word.toUpperCase();
        }
        // Otherwise, convert to Title Case.
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
  return text;
};

const getLinkText = async (url) => {
  try {
    await initiate_interval_tree();
    const pageContext = getUrlContext(new URL(url).pathname) || [];
    const groupKey =
      pageContext.map((c) => formatText(JSON.parse(c).label)).join(' > ') ||
      'Uncategorized';
    return groupKey;
  } catch (error) {
    console.error('Error generating link text:', error);
    // Fallback to the hostname if parsing fails
    try {
      const hostname = new URL(url).hostname;
      return hostname;
    } catch {
      return 'Link'; // Final fallback
    }
  }
};
export const updateLinkTitles = async (inputText) => {
  if (typeof inputText !== 'string') return;

  const emptyLinkRegex = /\[\]\(([^)]+)\)/g;
  const matches = [...inputText.matchAll(emptyLinkRegex)];

  if (matches.length === 0) {
    return inputText;
  }

  let newText = inputText;
  // Use Promise.all to fetch all link titles concurrently
  await Promise.all(
    matches.map(async (match) => {
      const url = match[1];
      const linkText = await getLinkText(url);
      // Replace the specific instance of the empty link
      newText = newText.replace(match[0], `[${linkText}](${url})`);
    })
  );

  return newText;
};
export const useOpenBook = () => {
  // Call the hook here to get the navigate function
  const navigate = useNavigate();

  // Return the handler function that your component will call
  const handleOpenBook = (e, url) => {
    console.log('Opening resource:', url);

    if (!isSameOrigin(url)) {
      return false;
    }

    try {
      const newUrl = new URL(url, window.location.origin);
      e.preventDefault();

      bookHistory.set(key_bookUrl, {
        shortUrl: e.target.href,
        longUrl: getServerBookUrlFromUrl(url),
      });

      const finalUrl = newUrl.pathname + newUrl.search;
      console.log('Final URL:', finalUrl);

      // Use the navigate function from the hook
      navigate(finalUrl);
    } catch (error) {
      console.error('Error navigating:', error);
      return false; // Let the browser handle the link
    }
  };

  return handleOpenBook;
};
